import * as actionTypes from "./action-types";

export const setDataTableState = (dataTableState) => {
    return {
        type: actionTypes.SET_DATATABLE_STATE,
        ...dataTableState
    }
}